module.exports = __webpack_public_path__ + "img/bar-chart-light-01.b35f4b63.jpg";